module.exports = __webpack_public_path__ + "static/media/emily-willis-lesb.a8fb363f.jpg";